import { render } from "./EditorDrawerHost.vue?vue&type=template&id=488fc240&scoped=true"
import script from "./EditorDrawerHost.vue?vue&type=script&lang=js"
export * from "./EditorDrawerHost.vue?vue&type=script&lang=js"

import "./EditorDrawerHost.vue?vue&type=style&index=0&id=488fc240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488fc240"]])

export default __exports__